import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import {
  DEFAULT_WEBSITE_THEME_ID,
  websiteThemePresetIds,
} from "src/themes/presets";

export const colorSchemes = websiteThemePresetIds;

export type ColorSchemes = (typeof colorSchemes)[number];

interface ColorSchemeState {
  value: string;
}

const initialState: ColorSchemeState = {
  value: DEFAULT_WEBSITE_THEME_ID,
};

export const colorSchemeSlice = createSlice({
  name: "colorScheme",
  initialState,
  reducers: {
    setColorScheme: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        value: action.payload,
      };
    },
  },
});

export const { setColorScheme } = colorSchemeSlice.actions;

export const selectColorScheme = (state: RootState) => {
  return state.colorScheme.value;
};

export default colorSchemeSlice.reducer;
